export default __webpack_public_path__ + "static/media/master_bv77e.c11d628a.jpg";